import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/reset.module.scss';
import './styles/global.module.scss';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
);
